import { NavLink } from "react-router-dom";
import styled from "styled-components";

const StyledNav = styled.nav`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  ul {
    display: flex;
    list-style: none;
    column-gap: 20px;
    margin: 0px;
    padding: 0px;
    li {
      margin: 0px;
      padding: 0px;
      a {
        font-size: 16px;
        font-weight: 500;
        text-decoration: none;
        margin: 0px;
        padding: 10px;
        color: #000000;
        transition: color 0.5s ease;
        &:hover,
        &.active {
          color: #ee7d09;
          transition: color 0.5s ease;
        }
      }
    }
  }
`;

const Navigation = () => {
  return (
    <StyledNav>
      <ul>
        <li>
          <NavLink
            to="/"
            className={({ isActive }) => isActive && "active"}
            title="Home"
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/products"
            className={({ isActive }) => isActive && "active"}
            title="Products"
          >
            Products
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/farm"
            className={({ isActive }) => isActive && "active"}
            title="Farm"
          >
            Farm
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/process"
            className={({ isActive }) => isActive && "active"}
            title="Process"
          >
            Process
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/about"
            className={({ isActive }) => isActive && "active"}
            title="About"
          >
            About
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/contact"
            className={({ isActive }) => isActive && "active"}
            title="Contact"
          >
            Contact
          </NavLink>
        </li>
      </ul>
    </StyledNav>
  );
};

export default Navigation;
